import React from "react";
import { CTAButton } from "./CTAButton";
import { painPoints } from "../data/landing";
export function PainPoints() {
  return <section className="bg-navy-900 px-5 py-16 text-white sm:py-20" data-id="element-255" data-mp="2lmspkkrd14js">
      <div className="mx-auto max-w-5xl" data-id="element-256" data-mp="26z7osxhyjhf1">
        <div className="mx-auto max-w-2xl text-center" data-id="element-257" data-mp="26y621vrkx6hh">
          <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-258" data-mp="2bwqzjnfg5c28">
            Do Any of These Situations <span className="text-gold-400" data-id="element-259" data-mp="1xwoq8pl7fqyl">Sound Familiar?</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-navy-200" data-id="element-260" data-mp="21zlaslub1x56">
            If you recognize yourself in even one of these situations, Denture Blueprint™ was designed with your professional needs in mind.
          </p>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-261" data-mp="1sywwdq101urr">
          {painPoints.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="rounded-2xl bg-navy-800 p-5" data-id="element-262" data-mp="3nco58nbi8am5">
              <Icon className="h-7 w-7 text-gold-400" aria-hidden="true" data-id="element-263" data-mp="3nbwf3s0of539" />
              <h3 className="mt-3 text-lg font-bold leading-snug" data-id="element-264" data-mp="1yzdnoo4wyfnl">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-navy-200" data-id="element-265" data-mp="1u2dgub08p8vf">{text}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl space-y-4 text-center text-base leading-relaxed text-navy-200" data-id="element-266" data-mp="27rp4rje50qqw">
          <p data-id="element-267" data-mp="23s6std4anq07">And here's something I want you to remember: <strong className="text-white" data-id="element-268" data-mp="1g1atluxidsix">having more information doesn't always mean having an easier way to use it.</strong></p>
          <p data-id="element-269" data-mp="1b4182qd8q10d">The problem isn't necessarily that you lack knowledge.</p>
          <p className="font-display text-2xl font-bold leading-snug text-gold-300" data-id="element-270" data-mp="1p30l10re4rgp">
            Sometimes, what you need is a better system for organizing and consulting the knowledge you already have.
          </p>
          <p data-id="element-271" data-mp="30gmjxdn1y7ff">That's exactly why I created Denture Blueprint™.</p>
        </div>
        <div className="mt-8" data-id="element-272" data-mp="2vitbsf26v3ci">
          <CTAButton label="Yes, I Want a More Structured System" data-id="element-273" data-mp="2vhrq7gnjqygj" />
        </div>
      </div>
    </section>;
}